export default function LittleRockTravelTimingSection() {
  return (
    <section id="timing" className="py-16 md:py-24 bg-[#F7F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Travel Timing</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">When Little Rock Travelers Need Passports</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { month: "January–February", title: "Winter Escape", desc: "Post-holiday Caribbean and Mexico cruises. Spring break planning begins." },
            { month: "March–April", title: "Spring Break Peak", desc: "Cancun, Jamaica, and Dominican Republic are top destinations. Rush orders spike." },
            { month: "May–June", title: "Summer Prep", desc: "European vacations and study abroad programs. Families book 3–4 months out." },
            { month: "July–August", title: "Summer Travel", desc: "Peak international travel season. Last-minute passport requests are common." },
            { month: "September–October", title: "Off-Season Deals", desc: "Fewer passport requests but ideal for renewal before holiday travel." },
            { month: "November–December", title: "Holiday Rush", desc: "Winter cruises and holiday trips to Europe. Emergency orders peak." },
          ].map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <p className="text-[#F6C344] text-xs font-bold uppercase tracking-wider mb-2">{t.month}</p>
              <h3 className="font-bold text-[#1A365D] text-lg mb-2">{t.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}